module.exports = __webpack_public_path__ + "img/danger.e9f74233.png";